import axios from "axios";
import { ProblemDetails } from "../types";

/**
 * The ingestion endpoints explain 400/404/409 responses in a ProblemDetails
 * body (for example "Client 12 does not exist."), which is more useful to the
 * user than a generic message. 500s carry no detail, so they use the fallback.
 */
const getApiErrorMessage = (error: unknown, fallback: string): string => {
  if (!axios.isAxiosError(error)) {
    return fallback;
  }

  const body: unknown = error.response?.data;
  if (typeof body !== "object" || body === null) {
    return fallback;
  }

  const { detail, title } = body as ProblemDetails;
  return detail || title || fallback;
};

export default getApiErrorMessage;
